import { CarouselManager } from "../utils/carouselManager";

document.addEventListener("search:searchPoppup", (e) => {
  doSearchPoppup(e.detail.currentInput, e.detail._this2);
});

document.addEventListener('click', async (e) => {
  const clickedEl = e.target.closest('.js-facet-redirect')
  if (clickedEl) {
    const redirectKey = clickedEl.dataset.facetKey
    const redirectValue = clickedEl.dataset.facetValue
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'click_autocomplete_ta',
      search_query: redirectValue,
      autocomplete_type: redirectKey
    });
    
    sessionStorage.setItem('redirectKey', redirectKey)
    
  }
})

class HeaderSearchbar extends HTMLElement {
  constructor() {
    super();

    this.inputElement = this.querySelector('[name="q"]');
    this.searchResultsElement = this.querySelector(".js-search-results");
    this.clearInputElement = this.querySelector('[data-action="clear-input"]');
    this.unfixSearchElement = this.querySelector('[data-action="unfix-search"]');
    this.searchProductTypeElement = this.querySelector("#search-product-type");
    this.header = this.closest(".header");
    this.searchBarElement = this.querySelector("form");
    this.swiperEl = this.querySelector(".swiper");
    this.swiper;
    this.productTypeFilter = "";
    this.isSearchOpen = false;
    window.disableScrollRemove = false;
  }

  connectedCallback() {
    this._attachEventListeners();
    // this._initNoResultCarousel();
  }

  _attachEventListeners() {
    this.clearInputElement.addEventListener("click", this._clearInput.bind(this));
    this.unfixSearchElement?.addEventListener("click", this._unfixMobileSearch.bind(this));
    this.inputElement.addEventListener("focusin", this._onInputFocus.bind(this));
    this.inputElement.addEventListener("focusout", this._onFocusOut.bind(this));
    this.inputElement.addEventListener("keydown", this._handleTab.bind(this));
    this.inputElement.addEventListener("input", this._debounce(this._doSearch.bind(this), 250));
    this.searchProductTypeElement?.addEventListener("change", this._productTypeChanged.bind(this));
    this.searchBarElement.addEventListener("submit", this._onFormSubmit.bind(this));
  }

  _clearInput() {
    this.setAttribute("aria-expanded", false);
    this.inputElement.focus();
    this.inputElement.blur();
    this.inputElement.value = "";
    this.searchResultsElement.setAttribute("aria-hidden", "true");
    document.documentElement.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("max-height");
  }

  _unfixMobileSearch() {
    this.classList.remove("is-fixed");
    this.searchBarElement.setAttribute("aria-expanded", false);
    this.searchResultsElement.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-mobile-scroll");
  }

  _onInputFocus() {
    window.disableScrollRemove = true;
    this.classList.add("is-fixed");
    document.body.classList.add("no-mobile-scroll");

    if (this.inputElement.value === "") {
      this.searchResultsElement.setAttribute("aria-hidden", "true");
    } else {
      this.searchResultsElement.setAttribute("aria-hidden", "false");
      this.inputElement.classList.add("is-filled");
      this.searchBarElement.setAttribute("aria-expanded", true);
    }
  }

  _onFocusOut(event) {
    window.disableScrollRemove = false;
    // Early return for mobile - combine both width checks
    if (window.innerWidth <= 640 || 
        event.target.classList.contains("js-searchbar-input") || 
        event.target.closest(".js-searchbar-content")) {
      return;
    }

    // Cache DOM queries
    const relatedTarget = event.relatedTarget;
    
    // Batch DOM updates with requestAnimationFrame
    requestAnimationFrame(() => {
      this.classList.remove("is-fixed");
      document.body.classList.remove("no-mobile-scroll");
      
      if (!this.contains(relatedTarget)) {
        // Batch attribute changes
        this.searchBarElement.setAttribute("aria-expanded", false);
        this.searchResultsElement.setAttribute("aria-hidden", true);
      }
    });
  }

  _handleTab(event) {
    if (event.key !== "Tab") {
      return;
    } // Try to get the first link into the results to give focus to this element

    const firstFocusableElement = this.searchResultsElement.querySelector("a");

    if (firstFocusableElement) {
      firstFocusableElement.focus();
      event.preventDefault();
    }
  }

  _doSearch() {
    // Set the main component's expanded state based on whether there's any input
    if (this.inputElement.value.length > 0) {
      this.setAttribute("aria-expanded", true);
      if(window.innerWidth < 640) {
        document.documentElement.style.setProperty("overflow", "hidden");
        document.documentElement.style.setProperty("max-height", "100dvh");
      }
    } else {
      this.setAttribute("aria-expanded", false);
      if(window.innerWidth < 640) {
        document.documentElement.style.removeProperty("overflow", "hidden");
        document.documentElement.style.removeProperty("max-height", "100dvh");
      }
    }

    // Store the current input value to prevent race conditions in async search
    this.lastInputValue = this.inputElement.value;

    // Handle different search states based on input length:
    if (this.inputElement.value === "") {
      // When input is empty: collapse the search results
      this.searchBarElement.setAttribute("aria-expanded", false);
      this.searchResultsElement.setAttribute("aria-hidden", "true");
    } else if(this.inputElement.value.length <= 2) {
      // When input is 1-2 characters: show results container but don't trigger search yet
      this.searchResultsElement.setAttribute("aria-hidden", "false");
    } else {
      // When input is 3+ characters: show results, set loading state, and expand search
      this.searchResultsElement.setAttribute("aria-hidden", "false");
      this.searchBarElement.setAttribute("aria-busy", true);  // Shows loading state
      this.searchBarElement.setAttribute("aria-expanded", true);
    }

    doSearchPoppup(this.inputElement.value, this);
  }

  _productTypeChanged(event, target) {
    target.closest(".search-bar__filter").querySelector(".search-bar__filter-active").innerText =
      target.options[target.selectedIndex].innerText;
    this.productTypeFilter = target.value;

    if (this.inputElement.value !== "") {
      this._doSearch();
    }
  }

  _onFormSubmit(event) {
    if (!this.inputElement.value.trim()) {
      event.preventDefault();
      setTimeout(() => {
        this.inputElement.focus();
        this.inputElement.dispatchEvent(new Event("focusin", { bubbles: true, cancelable: true }));
      }, 0);
      return;
    }
    sessionStorage.setItem("defaultFilters", "");
    sessionStorage.setItem("productsPerPage", "");
    sessionStorage.setItem("currentPage", "");
    sessionStorage.setItem("sortPageMode", "");
    var cloneNode = this.inputElement.cloneNode();
    cloneNode.setAttribute("type", "hidden");
    cloneNode.value = "";

    if (this.productTypeFilter !== "") {
      cloneNode.value += "product_type:".concat(this.productTypeFilter);
      if (this.inputElement.value !== "") {
        cloneNode.value += " AND ";
      }
    }

    cloneNode.value += this.inputElement.value; // We remove the "q" attribute on existing node so it's not submitted

    this.inputElement.removeAttribute("name"); // And we insert it into the DOM

    this.inputElement.insertAdjacentElement("afterend", cloneNode);
  }

  _initNoResultCarousel() {
    this.swiper = CarouselManager.create(this.swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 12,
      breakpoints: {
        640: {
          spaceBetween: 16,
        },
      },
    });
  }

  _debounce(fn, delay) {
    let timeoutId;

    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  disconnectedCallback() {
    // Clean up event listeners
    this.removeEventListener('focusout', this._handleFocusOut);
    this.searchInput?.removeEventListener('input', this._handleSearch);
  }
}

customElements.define("header-searchbar", HeaderSearchbar);


// search in Header input
async function doSearchPoppup(currentInput, _this2) {
  // Early return if input has changed during async operation
  if (_this2.lastInputValue !== currentInput) {
    return;
  }

  // Configuration
  
  const url = window.Shopify.routes.root + "apps/search";

  try {
    // Fetch search results
    const autocompleteResults = await getAutocompleteResults(
      currentInput,
      _this2,
      url
    );

    // Update loading state
    _this2.searchBarElement.setAttribute('aria-busy', false);

    // Generate template
    const searchPoppupListTemplate = templateBlockSearchList.innerHTML
      .replaceAll("[searchAutocomplete]", autocompleteResults.templateAutocompleteList)
      .replaceAll("[searchedText]", currentInput);

    // Update UI based on search results
    if (autocompleteResults.emptySearch) {
      emptySearchBlock.querySelector('.js-search-text').innerHTML = currentInput;
    } 
    notEmptySearchBlock.setAttribute('aria-hidden', false);
    notEmptySearchBlock.innerHTML = searchPoppupListTemplate;

  } catch (error) {
    console.error('Search failed:', error);
    _this2.searchBarElement.setAttribute('aria-busy', false);
  }
}


// call autocomplete in header search input
async function getAutocompleteResults(currentInput, _this2, url) {
  try {
    const data = await fetchAutocompleteData(currentInput, url);
    const completionResults = data.completionResults;
    const templateAutocomplete = templateBlockAutocomplete.innerHTML;
    const templateAutocompleteEmpty = templateBlockAutocompleteEmpty.innerHTML;
    if (!completionResults) {
      return createEmptySearchTemplate(currentInput, templateAutocompleteEmpty);
    }

    const sortedResults = sortCompletionResults(completionResults);
    return createPopulatedSearchTemplate(sortedResults, templateAutocomplete);
  } catch (error) {
    console.error('Autocomplete error:', error);
    return { templateAutocompleteList: '', emptySearch: true };
  }
}

async function fetchAutocompleteData(currentInput, url) {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      query: currentInput.trim(),
      rout: "autocomplete",
      visitorId: localStorage.getItem("visitorId")
    })
  };

  const response = await fetch(url, options);
  return response.ok ? response.json() : response.text();
}

function sortCompletionResults(results) {
  return results.sort((a, b) => {
    const aType = a.attributes.type?.text[0];
    const bType = b.attributes.type?.text[0];
    
    if (aType === "opus" && bType !== "opus") return -1;
    if (aType !== "opus" && bType === "opus") return 1;
    return 0;
  });
}

function createPopulatedSearchTemplate(results, templateAutocomplete) {
  const autocompleteListTemplate = results
    .map(result => generateResultTemplate(result, templateAutocomplete))
    .join("");

  const templateAutocompleteList = templateBlockAutocompleteList.innerHTML
    .replaceAll("[listAutocomplete]", autocompleteListTemplate);

  return { 
    templateAutocompleteList,
    emptySearch: false 
  };
}

function getAutocompleteUrl(result) {
  const facetKey = result.attributes.type.text[0]
  const facetValue = result.suggestion
  const facetOpusArray = result.attributes.main_reference_id?.text
  const facetOpus = facetOpusArray ? facetOpusArray[0] : ''
  const origin = window.location.origin
  if (facetKey == 'opus') {
    return `${origin}/products/${facetOpus}`
  } else {
    return `${origin}/pages/search?q=${encodeURIComponent(facetValue)}`
  }
}

function generateResultTemplate(result, templateAutocomplete) {
  const hasImage = result.attributes.image?.text;
  const subtitle = result.attributes.subtitle?.text 
    ? `| ${result.attributes.subtitle.text[0]}` 
    : '';

  const url = getAutocompleteUrl(result)
  
  return templateAutocomplete
    .replaceAll("[facetValue]", result.suggestion)
    .replaceAll("[url]", url)
    .replaceAll("[facetKey]", result.attributes.type.text[0])
    .replaceAll(
      "[facetKeyTranslate]",
      `${autocompleteSuggestionTranslate[result.attributes.type.text[0]]} ${subtitle}`
    )
    .replaceAll(
      "[facetOpus]",
      result.attributes.main_reference_id?.text 
        ? result.attributes.main_reference_id.text[0] 
        : ""
    )
    .replaceAll(
      "[facetImageSrc]",
      hasImage ? result.attributes.image.text[0] : ""
    )
    .replaceAll("[imageClass]", hasImage ? "" : "jc-hidden")
    .replaceAll("[facetSearchIcon]", hasImage ? "jc-hidden" : "");
}

function createEmptySearchTemplate(currentInput, templateAutocomplete) {
  const origin = window.location.origin

  const autocompleteListTemplate = templateAutocomplete
    .replaceAll("[facetValue]", currentInput.trim())
    .replaceAll("[url]", `${origin}/search?q=${encodeURIComponent(currentInput)}`)

  const templateAutocompleteList = templateBlockAutocompleteList.innerHTML
    .replaceAll("[listAutocomplete]", autocompleteListTemplate);

  return { 
    templateAutocompleteList,
    emptySearch: true 
  };
}

const autocompleteSuggestionTranslate = {
  opus: "Livre",
  author: "Auteur",
  publisher: "Editeur",
  babelio_tag: "Thème",
  series: "Série",
  category: "Catégorie",
};

// list of templates
const templateBlockSearchList = document.getElementById(
  "search-poppup-template-search-list"
);
const templateBlockSearchAuthor = document.getElementById(
  "search-poppup-template-search-edition"
);
const templateBlockSearchListAuthor = document.getElementById(
  "search-poppup-template-search-list-editions"
);
  const templateBlockAutocomplete = document.getElementById(
    "search-poppup-template-autocomplete"
  );
const templateBlockAutocompleteList = document.getElementById(
  "search-poppup-template-autocomplete-list"
);
const templateBlockAutocompleteEmpty = document.getElementById(
  "search-poppup-template-autocomplete-empty"
);
const notEmptySearchBlock = document.querySelector(".js-search-not-empty");
const emptySearchBlock = document.querySelector(".js-search-empty");
